import { useEffect, useState, useRef } from 'react';

interface UseFitTableRowsOptions {
  rowHeight?: number;
  headerHeight?: number;
  paginationHeight?: number;
  bufferRows?: number;
  minHeightForDynamic?: number;
}

export const useFitTableRows = ({
  rowHeight = 55,
  headerHeight = 55,
  paginationHeight = 80,
  bufferRows = 2,
  minHeightForDynamic = 200
}: UseFitTableRowsOptions = {}) => {
  const [limit, setLimit] = useState<number>(() => {
    if (typeof window === 'undefined') return 10;
    return 0;
  });
  const tableRef = useRef<HTMLDivElement>(null);
  const hasCalculatedOnce = useRef(false);

  const calculateLimit = () => {
    if (!tableRef.current) return;

    const screenHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

    if (screenHeight < minHeightForDynamic) {
      return;
    }

    const tableTop = tableRef.current.getBoundingClientRect().top;
    const pixelBuffer = 2;
    const availableHeight = screenHeight - tableTop - paginationHeight - 40 - pixelBuffer;

    const totalRows = Math.floor((availableHeight - headerHeight) / rowHeight);
    const adjustedRows = Math.max(totalRows - bufferRows, 10);

    if (adjustedRows !== limit || !hasCalculatedOnce.current) {
      setLimit(adjustedRows);
      hasCalculatedOnce.current = true;
    }
  };

  useEffect(() => {
    calculateLimit();
    window.addEventListener('resize', calculateLimit);
    return () => window.removeEventListener('resize', calculateLimit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { limit, setLimit, tableRef };
};
